import Application from "../../Application";
import { IValueListService } from "../../service/valuelist/ValueListService";

export default class GetAttributeCodeListInteractor {
  private application: Application;
  private valueListService: IValueListService;

  constructor(application, valueListService) {
    this.application = application;
    this.valueListService = valueListService;
  }

  async execute() {
    return this.valueListService.getValueListLabels();
  }
}
